import { render } from "./VueFileInput.vue?vue&type=template&id=c90b3388&scoped=true"
import script from "./VueFileInput.vue?vue&type=script&lang=js"
export * from "./VueFileInput.vue?vue&type=script&lang=js"

import "./VueFileInput.vue?vue&type=style&index=0&id=c90b3388&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c90b3388"]])

export default __exports__